package com.evoapps.evoshift.ui.roster

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.selection.toggleable
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowForward
import androidx.compose.material.icons.automirrored.filled.KeyboardArrowLeft
import androidx.compose.material.icons.automirrored.filled.KeyboardArrowRight
import androidx.compose.material.icons.filled.ContentCopy
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.FilterChip
import androidx.compose.material3.FilterChipDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.stateDescription
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.widgets.IconButtonWithTooltip
import com.evoapps.evoshift.domain.usecase.roster.CopyOpenReason
import com.evoapps.evoshift.domain.usecase.roster.CopyPreview
import com.evoapps.evoshift.domain.usecase.roster.DayCopyOutcome
import com.evoapps.evoshift.domain.usecase.roster.PlannedDaysMode
import com.evoapps.evoshift.ui.DarkGold
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.LightGold
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.ui.util.closureLabel
import com.evoapps.evoshift.ui.util.dayAndDate
import com.evoapps.evoshift.ui.util.dayAndMonth
import com.evoapps.evoshift.ui.util.dayShort
import com.evoapps.evoshift.ui.util.monthName
import com.evoapps.evoshift.viewmodels.CopyToolStep
import com.evoapps.evoshift.viewmodels.CopyToolUiState
import com.evoapps.evoshift.widgets.DialogAction
import com.evoapps.evoshift.widgets.DialogWidth
import com.evoapps.evoshift.widgets.EvoToolDialog
import com.evoapps.evoshift.viewmodels.CopyToolAction
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.rememberScrollState
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.copy_day_calendar_closed
import evoshift.composeapp.generated.resources.copy_day_calendar_planned
import evoshift.composeapp.generated.resources.copy_day_calendar_source
import evoshift.composeapp.generated.resources.copy_day_clear
import evoshift.composeapp.generated.resources.copy_day_day_alongside
import evoshift.composeapp.generated.resources.copy_day_day_kept
import evoshift.composeapp.generated.resources.copy_day_day_replaces
import evoshift.composeapp.generated.resources.copy_day_day_shifts
import evoshift.composeapp.generated.resources.copy_day_day_without
import evoshift.composeapp.generated.resources.copy_day_every_fri
import evoshift.composeapp.generated.resources.copy_day_every_mon
import evoshift.composeapp.generated.resources.copy_day_every_sat
import evoshift.composeapp.generated.resources.copy_day_every_sun
import evoshift.composeapp.generated.resources.copy_day_every_thu
import evoshift.composeapp.generated.resources.copy_day_every_tue
import evoshift.composeapp.generated.resources.copy_day_every_wed
import evoshift.composeapp.generated.resources.copy_day_line
import evoshift.composeapp.generated.resources.copy_day_line_from
import evoshift.composeapp.generated.resources.copy_day_nothing_on_day
import evoshift.composeapp.generated.resources.copy_day_nothing_on_targets
import evoshift.composeapp.generated.resources.copy_day_picked
import evoshift.composeapp.generated.resources.copy_day_skipped_closed
import evoshift.composeapp.generated.resources.copy_day_skipped_planned
import evoshift.composeapp.generated.resources.copy_day_source_shifts
import evoshift.composeapp.generated.resources.copy_day_whole_week
import evoshift.composeapp.generated.resources.copy_days_back
import evoshift.composeapp.generated.resources.copy_days_calendar_sources
import evoshift.composeapp.generated.resources.copy_days_calendar_start
import evoshift.composeapp.generated.resources.copy_days_calendar_target
import evoshift.composeapp.generated.resources.copy_days_outside_month
import evoshift.composeapp.generated.resources.copy_tool_pick_days
import evoshift.composeapp.generated.resources.copy_tool_pick_start
import evoshift.composeapp.generated.resources.copy_tool_copy_days
import evoshift.composeapp.generated.resources.copy_from_previewing
import evoshift.composeapp.generated.resources.copy_tool_calendar_start
import evoshift.composeapp.generated.resources.copy_tool_calendar_targets
import evoshift.composeapp.generated.resources.copy_tool_from_summary
import evoshift.composeapp.generated.resources.copy_tool_loading_month
import evoshift.composeapp.generated.resources.copy_tool_next
import evoshift.composeapp.generated.resources.copy_tool_next_month
import evoshift.composeapp.generated.resources.copy_tool_pick_target
import evoshift.composeapp.generated.resources.copy_tool_previous_month
import evoshift.composeapp.generated.resources.copy_tool_repeat
import evoshift.composeapp.generated.resources.copy_tool_step_source
import evoshift.composeapp.generated.resources.copy_tool_step_target_block
import evoshift.composeapp.generated.resources.copy_tool_step_target_day
import evoshift.composeapp.generated.resources.copy_tool_title
import evoshift.composeapp.generated.resources.copy_tool_week
import evoshift.composeapp.generated.resources.copy_tool_workdays
import evoshift.composeapp.generated.resources.copy_tool_whole_previous_month
import evoshift.composeapp.generated.resources.copy_tool_step_target_month
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.DayOfWeek
import kotlinx.datetime.LocalDate
import kotlinx.datetime.isoDayNumber
import kotlinx.datetime.plus
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.pluralStringResource
import org.jetbrains.compose.resources.stringResource

/** SH-205: test tags of the "Copy shifts" tool. */
object CopyToolTags {
    /** SH-215: the top bar's "Copy shifts" (on a phone the day sheet's ⋮ too, SH-222). */
    const val OPEN = "copy_tool_open"
    /** SH-222: the phone day sheet's ⋮ and its "Kopiuj ten dzień…" (the sheet covers the top bar). */
    const val DAY_SHEET_MENU = "copy_tool_day_sheet_menu"
    const val DAY_SHEET_COPY = "copy_tool_day_sheet_copy"
    const val EVERY_WEEKDAY = "copy_tool_every_weekday"
    const val WORKDAYS = "copy_tool_workdays"
    const val WHOLE_WEEK = "copy_tool_whole_week"
    const val CLEAR = "copy_tool_clear"
    const val REPEAT = "copy_tool_repeat"
    const val WHOLE_PREVIOUS_MONTH = "copy_tool_whole_previous_month"
    const val OUTSIDE_MONTH = "copy_tool_outside_month"
    const val PREVIOUS_MONTH = "copy_tool_previous_month"
    const val NEXT_MONTH = "copy_tool_next_month"
    fun day(date: LocalDate) = "copy_tool_day_$date"
    fun week(start: LocalDate) = "copy_tool_week_$start"
    fun outcome(date: LocalDate) = "copy_tool_outcome_$date"
}

/** SH-171: "Every Monday in the month" and so on (the weekday's grammatical gender differs). */
fun copyDayEveryWeekdayRes(day: DayOfWeek): StringResource = when (day) {
    DayOfWeek.MONDAY -> Res.string.copy_day_every_mon
    DayOfWeek.TUESDAY -> Res.string.copy_day_every_tue
    DayOfWeek.WEDNESDAY -> Res.string.copy_day_every_wed
    DayOfWeek.THURSDAY -> Res.string.copy_day_every_thu
    DayOfWeek.FRIDAY -> Res.string.copy_day_every_fri
    DayOfWeek.SATURDAY -> Res.string.copy_day_every_sat
    else -> Res.string.copy_day_every_sun
}

/** SH-205: the copied days as the subtitle words them: "2 listopada", "26 października – 1 listopada" or a list. */
@Composable
fun copySourcesLabel(sources: Set<LocalDate>): String {
    val sorted = sources.sorted()
    if (sorted.size > 1 && sorted.last().toEpochDays() - sorted.first().toEpochDays() + 1 == sorted.size.toLong()) {
        return "${dayAndMonth(sorted.first())} – ${dayAndMonth(sorted.last())}"
    }
    return sorted.map { dayAndMonth(it) }.joinToString(", ")
}

/**
 * SH-205: the one "Copy shifts" tool for days, weeks and ranges, in two steps. Where from: a day,
 * several days, a week or any range, also from an earlier month (a compact calendar: tap a day,
 * a week's number, or a second day for the range between; the month switcher). Where to: one day
 * is ticked onto days (quick picks: every same weekday, every working day, the whole week); a
 * block starts on a day, once or repeated back to back until the month ends. Then SH-199's Skip,
 * Add or Replace when target days have shifts, and the live preview, totals and day by day
 * (people where they still fit, otherwise without a person and why; closed days skipped). Copy
 * writes it in one batch; the snackbar then offers one Undo.
 */
@Composable
fun CopyShiftsDialog(
    state: CopyToolUiState,
    onTapSource: (LocalDate) -> Unit,
    onPickWeek: (LocalDate) -> Unit,
    onWholePreviousMonth: () -> Unit,
    onShowMonth: (Int) -> Unit,
    onNext: () -> Unit,
    onBack: () -> Unit,
    onTapTarget: (LocalDate) -> Unit,
    onToggleTargets: (Set<LocalDate>) -> Unit,
    onClearTargets: () -> Unit,
    onRepeat: (Boolean) -> Unit,
    onPlannedDays: (PlannedDaysMode) -> Unit,
    onCopy: () -> Unit,
    onDismiss: () -> Unit
) {
    val target = state.step == CopyToolStep.TARGET
    val subtitle = if (state.sources.isEmpty()) null else
        stringResource(Res.string.copy_tool_from_summary, copySourcesLabel(state.sources)) +
            (if (state.loadingMonth) "" else " · " + pluralStringResource(Res.plurals.copy_day_source_shifts, state.sourceShifts, state.sourceShifts))
    // SH-229: a full-screen sheet on a phone (the calendar whole, a close ✕, one bottom bar with
    // Back and the main button); the dialog card elsewhere, with the same header and bar.
    EvoToolDialog(
        title = stringResource(Res.string.copy_tool_title),
        subtitle = subtitle,
        icon = Icons.Default.ContentCopy,
        onDismiss = onDismiss,
        width = DialogWidth.Compact,
        confirm = if (target) {
            when (state.copyAction) {
                CopyToolAction.PICK_DAYS -> DialogAction(stringResource(Res.string.copy_tool_pick_days), onCopy, enabled = false)
                CopyToolAction.PICK_START -> DialogAction(stringResource(Res.string.copy_tool_pick_start), onCopy, enabled = false)
                CopyToolAction.COPY -> DialogAction(
                    pluralStringResource(Res.plurals.copy_tool_copy_days, state.targetDaysInMonth, state.targetDaysInMonth),
                    onCopy,
                    enabled = state.canCopy,
                    icon = Icons.Default.ContentCopy
                )
            }
        } else {
            DialogAction(stringResource(Res.string.copy_tool_next), onNext, enabled = state.canContinue, icon = Icons.AutoMirrored.Filled.ArrowForward)
        },
        back = if (target) DialogAction(stringResource(Res.string.copy_days_back), onBack) else null,
        bodyArrangement = Arrangement.spacedBy(8.dp)
    ) {
        val content = LocalContentColor.current
        val step = when {
            !target -> Res.string.copy_tool_step_source
            state.wholePreviousMonth -> Res.string.copy_tool_step_target_month
            state.isSingleDay -> Res.string.copy_tool_step_target_day
            else -> Res.string.copy_tool_step_target_block
        }
        Text(stringResource(step), color = content.copy(alpha = 0.85f), style = MaterialTheme.typography.bodyMedium)
        if (!target) {
            // The old "previous month" in one tap: every day of it, by weekday, onto the whole month.
            ChipRow {
                Chip(stringResource(Res.string.copy_tool_whole_previous_month), state.wholePreviousMonth, CopyToolTags.WHOLE_PREVIOUS_MONTH, chipColors(), onWholePreviousMonth)
            }
            when {
                state.loadingMonth -> Progress(stringResource(Res.string.copy_tool_loading_month))
                state.sources.isNotEmpty() && state.sourceShifts == 0 ->
                    Text(stringResource(Res.string.copy_day_nothing_on_day), color = LightGold, style = MaterialTheme.typography.bodyMedium)
            }
            CopyCalendar(
                year = state.shownYear,
                month = state.shownMonth,
                firstDayOfWeek = state.firstDayOfWeek,
                hint = stringResource(Res.string.copy_days_calendar_sources),
                picked = state.sources,
                pickedRes = Res.string.copy_day_calendar_source,
                closedDays = state.closedDays,
                shiftsOn = state.shiftsOn,
                onDay = onTapSource,
                onWeek = onPickWeek,
                onPrevious = { onShowMonth(-1) }.takeIf { state.canShowEarlier },
                onNext = { onShowMonth(1) }.takeIf { state.canShowLater },
                switcher = true
            )
        } else {
            if (!state.wholePreviousMonth) TargetChoice(state, onToggleTargets, onClearTargets, onRepeat)
            CopyCalendar(
                year = state.year,
                month = state.month,
                firstDayOfWeek = state.firstDayOfWeek,
                hint = stringResource(if (state.isSingleDay || state.wholePreviousMonth) Res.string.copy_tool_calendar_targets else Res.string.copy_tool_calendar_start),
                picked = state.starts,
                pickedRes = if (state.isSingleDay) Res.string.copy_days_calendar_target else Res.string.copy_days_calendar_start,
                targets = state.targets,
                ringed = state.sources,
                closedDays = state.closedDays,
                shiftsOn = state.shiftsOn,
                onDay = { if (!state.wholePreviousMonth) onTapTarget(it) }
            )
            PlannedDaysChoice(state.preview, state.plannedDays, onPlannedDays)
            val preview = state.preview
            when {
                state.starts.isEmpty() && !state.wholePreviousMonth -> Text(stringResource(Res.string.copy_tool_pick_target), color = content.copy(alpha = 0.85f), style = MaterialTheme.typography.bodyMedium)
                state.isPreviewing || preview == null -> Progress(stringResource(Res.string.copy_from_previewing))
                else -> {
                    CopyPreviewCounts(preview, nothing = stringResource(Res.string.copy_day_nothing_on_targets))
                    if (preview.outsideMonth.isNotEmpty()) {
                        Text(
                            stringResource(Res.string.copy_days_outside_month, preview.outsideMonth.map { dayAndMonth(it) }.joinToString(", ")),
                            color = LightGold,
                            style = MaterialTheme.typography.bodyMedium,
                            modifier = Modifier.testTag(CopyToolTags.OUTSIDE_MONTH)
                        )
                    }
                    // A whole month would be a long list: its counts say it.
                    if (!state.wholePreviousMonth) DayOutcomes(preview, showSource = !state.isSingleDay)
                }
            }
        }
    }
}

@Composable
private fun Progress(text: String) {
    Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.padding(vertical = 8.dp)) {
        CircularProgressIndicator(modifier = Modifier.size(20.dp), color = DarkGold, strokeWidth = 2.dp)
        Spacer(Modifier.width(12.dp))
        Text(text, color = LocalContentColor.current.copy(alpha = 0.85f))
    }
}

/**
 * SH-229: the quick picks in one row that scrolls sideways (they never wrap into a 2 + 1 heap on a
 * phone and push the calendar down).
 */
@Composable
private fun ChipRow(content: @Composable androidx.compose.foundation.layout.RowScope.() -> Unit) {
    Row(
        Modifier.fillMaxWidth().horizontalScroll(rememberScrollState()),
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        verticalAlignment = Alignment.CenterVertically,
        content = content
    )
}

/** Where to: one day's quick picks, or a block's "Repeat until the month ends". */
@Composable
private fun TargetChoice(
    state: CopyToolUiState,
    onToggleTargets: (Set<LocalDate>) -> Unit,
    onClearTargets: () -> Unit,
    onRepeat: (Boolean) -> Unit
) {
    val colors = chipColors()
    ChipRow {
        if (state.isSingleDay) {
            val anchor = state.anchor
            val everyWeekday = state.everyWeekday
            if (anchor != null && everyWeekday.isNotEmpty()) {
                Chip(stringResource(copyDayEveryWeekdayRes(anchor.dayOfWeek)), state.starts.containsAll(everyWeekday), CopyToolTags.EVERY_WEEKDAY, colors) { onToggleTargets(everyWeekday) }
            }
            val workdays = state.workdays
            if (workdays.isNotEmpty()) {
                Chip(stringResource(Res.string.copy_tool_workdays), state.starts.containsAll(workdays), CopyToolTags.WORKDAYS, colors) { onToggleTargets(workdays) }
            }
            val week = state.wholeWeek
            if (week.isNotEmpty()) {
                Chip(stringResource(Res.string.copy_day_whole_week), state.starts.containsAll(week), CopyToolTags.WHOLE_WEEK, colors) { onToggleTargets(week) }
            }
            if (state.starts.isNotEmpty()) {
                Chip(stringResource(Res.string.copy_day_clear), false, CopyToolTags.CLEAR, colors, onClearTargets)
            }
        } else {
            Chip(stringResource(Res.string.copy_tool_repeat), state.repeat, CopyToolTags.REPEAT, colors) { onRepeat(!state.repeat) }
        }
    }
}

@Composable
private fun chipColors() = FilterChipDefaults.filterChipColors(
    containerColor = Color.White.copy(alpha = 0.08f),
    labelColor = Color.White,
    selectedContainerColor = LightGold,
    selectedLabelColor = DeepNavy
)

@Composable
private fun Chip(label: String, selected: Boolean, tag: String, colors: androidx.compose.material3.SelectableChipColors, onClick: () -> Unit) {
    FilterChip(
        selected = selected,
        onClick = onClick,
        label = { Text(label) },
        colors = colors,
        modifier = Modifier.handCursor().testTag(tag)
    )
}

/**
 * A month's calendar on a cream card (as the roster's other month calendars): [picked] days
 * filled, [targets] (where copies land) tinted, [ringed] (the copied days) circled, closed days
 * struck through, days with shifts dotted. With [onWeek], each week's number picks the week;
 * with [switcher], arrows show the month before or after ([onPrevious], [onNext] when allowed).
 */
@Composable
private fun CopyCalendar(
    year: Int,
    month: Int,
    firstDayOfWeek: Int,
    hint: String,
    picked: Set<LocalDate>,
    /** What a picked day is, for screen readers ("copied day", "pasted here", "pasted from here"). */
    pickedRes: StringResource,
    closedDays: Set<LocalDate>,
    shiftsOn: Map<LocalDate, Int>,
    onDay: (LocalDate) -> Unit,
    targets: Set<LocalDate> = emptySet(),
    ringed: Set<LocalDate> = emptySet(),
    onWeek: ((LocalDate) -> Unit)? = null,
    onPrevious: (() -> Unit)? = null,
    onNext: (() -> Unit)? = null,
    switcher: Boolean = false
) {
    val days = generateSequence(LocalDate(year, month, 1)) { it.plus(DatePeriod(days = 1)) }.takeWhile { it.month == LocalDate(year, month, 1).month }.toList()
    val first = firstDayOfWeek.takeIf { it in 1..7 } ?: 1
    val dayOrder = (0..6).map { (it + first - 1) % 7 + 1 }
    val offset = (days.first().dayOfWeek.isoDayNumber - first + 7) % 7
    val cells: List<LocalDate?> = List(offset) { null } + days
    val sourceLabel = stringResource(Res.string.copy_day_calendar_source)
    val pickedNote = stringResource(pickedRes)
    val targetLabel = stringResource(Res.string.copy_days_calendar_target)
    val closedLabel = stringResource(Res.string.copy_day_calendar_closed)
    val plannedLabel = stringResource(Res.string.copy_day_calendar_planned)
    val inMonthPicked = picked.count { it in days }
    Column(
        Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(20.dp))
            .background(Color(0xFFF7F2E9))
            .padding(12.dp),
        verticalArrangement = Arrangement.spacedBy(4.dp)
    ) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            if (switcher) {
                MonthArrow(Icons.AutoMirrored.Filled.KeyboardArrowLeft, stringResource(Res.string.copy_tool_previous_month), CopyToolTags.PREVIOUS_MONTH, onPrevious)
            }
            Text(
                "${monthName(month)} $year",
                style = MaterialTheme.typography.titleMedium,
                fontWeight = FontWeight.Bold,
                color = DeepNavy,
                textAlign = if (switcher) TextAlign.Center else TextAlign.Start,
                modifier = Modifier.weight(1f)
            )
            if (switcher) {
                MonthArrow(Icons.AutoMirrored.Filled.KeyboardArrowRight, stringResource(Res.string.copy_tool_next_month), CopyToolTags.NEXT_MONTH, onNext)
            }
        }
        Row(verticalAlignment = Alignment.CenterVertically) {
            Text(hint, style = MaterialTheme.typography.labelMedium, color = DeepNavy.copy(alpha = 0.75f), modifier = Modifier.weight(1f))
            if (inMonthPicked > 0) {
                Spacer(Modifier.width(8.dp))
                Text(
                    pluralStringResource(Res.plurals.copy_day_picked, picked.size, picked.size),
                    style = MaterialTheme.typography.labelMedium,
                    color = DeepNavy.copy(alpha = 0.75f)
                )
            }
        }
        val weekColumn = onWeek != null
        Row(Modifier.fillMaxWidth()) {
            if (weekColumn) Spacer(Modifier.width(WEEK_COLUMN))
            dayOrder.forEach { isoDay ->
                Text(
                    dayShort(DayOfWeek(isoDay)),
                    style = MaterialTheme.typography.labelSmall,
                    color = DeepNavy.copy(alpha = 0.7f),
                    textAlign = TextAlign.Center,
                    modifier = Modifier.weight(1f)
                )
            }
        }
        cells.chunked(7).forEach { week ->
            Row(Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
                if (onWeek != null) {
                    val start = com.evoapps.evoshift.viewmodels.CopyToolUiState.weekStart(week.first { it != null }!!, first)
                    val number = com.evoapps.evoshift.viewmodels.CopyToolUiState.weekNumber(start)
                    val name = stringResource(Res.string.copy_tool_week, number)
                    val whole = (0 until 7).all { start.plus(DatePeriod(days = it)) in picked }
                    Box(
                        Modifier
                            .width(WEEK_COLUMN)
                            .height(30.dp)
                            .clip(RoundedCornerShape(8.dp))
                            .background(if (whole) DeepNavy else DeepNavy.copy(alpha = 0.08f))
                            .handCursor()
                            .clickable(role = Role.Button, onClickLabel = name) { onWeek(start) }
                            .semantics { contentDescription = name }
                            .testTag(CopyToolTags.week(start)),
                        contentAlignment = Alignment.Center
                    ) {
                        Text(
                            number.toString(),
                            style = MaterialTheme.typography.labelMedium,
                            fontWeight = FontWeight.Bold,
                            color = if (whole) Color.White else DeepNavy
                        )
                    }
                }
                (0 until 7).forEach { index ->
                    val date = week.getOrNull(index)
                    Box(Modifier.weight(1f).height(40.dp), contentAlignment = Alignment.Center) {
                        if (date != null) DayCell(
                            date = date,
                            isPicked = date in picked,
                            isTarget = date in targets,
                            isRinged = date in ringed,
                            closed = date in closedDays,
                            planned = (shiftsOn[date] ?: 0) > 0,
                            notes = listOfNotNull(
                                sourceLabel.takeIf { date in ringed },
                                pickedNote.takeIf { date in picked },
                                targetLabel.takeIf { date in targets && date !in picked },
                                closedLabel.takeIf { date in closedDays },
                                plannedLabel.takeIf { (shiftsOn[date] ?: 0) > 0 }
                            ),
                            onClick = { onDay(date) }
                        )
                    }
                }
            }
        }
    }
}

private val WEEK_COLUMN = 30.dp

@Composable
private fun MonthArrow(icon: androidx.compose.ui.graphics.vector.ImageVector, label: String, tag: String, onClick: (() -> Unit)?) {
    IconButtonWithTooltip(onClick = { onClick?.invoke() }, enabled = onClick != null, modifier = Modifier.size(36.dp).handCursor().testTag(tag), tooltip = label) {
        Icon(icon, contentDescription = label, tint = if (onClick != null) DeepNavy else DeepNavy.copy(alpha = 0.3f))
    }
}

@Composable
private fun DayCell(
    date: LocalDate,
    isPicked: Boolean,
    isTarget: Boolean,
    isRinged: Boolean,
    closed: Boolean,
    planned: Boolean,
    notes: List<String>,
    onClick: () -> Unit
) {
    val name = dayAndDate(date)
    Box(
        modifier = Modifier
            .size(36.dp)
            .clip(CircleShape)
            .background(
                when {
                    isPicked -> DeepNavy
                    isTarget -> DarkGold.copy(alpha = 0.45f)
                    else -> Color.Transparent
                }
            )
            .then(if (isRinged) Modifier.border(2.dp, DarkGold, CircleShape) else Modifier)
            .handCursor()
            .toggleable(value = isPicked, role = Role.Checkbox, onValueChange = { onClick() })
            .semantics {
                contentDescription = name
                if (notes.isNotEmpty()) stateDescription = notes.joinToString(", ")
            }
            .testTag(CopyToolTags.day(date)),
        contentAlignment = Alignment.Center
    ) {
        Text(
            date.day.toString(),
            style = MaterialTheme.typography.bodyMedium,
            fontWeight = FontWeight.Bold,
            textDecoration = if (closed) TextDecoration.LineThrough else null,
            color = when {
                isPicked -> Color.White
                closed -> DeepNavy.copy(alpha = 0.55f)
                else -> DeepNavy
            }
        )
        if (planned) {
            Box(
                Modifier
                    .align(Alignment.BottomCenter)
                    .padding(bottom = 3.dp)
                    .size(4.dp)
                    .clip(CircleShape)
                    .background(if (isPicked) LightGold else DarkGold)
            )
        }
    }
}

/**
 * Day by day: "Monday, 16 November: 3 shifts, 1 without their person (approved absence: 1)" (with
 * the source day when several are copied), or why the day is not copied.
 */
@Composable
internal fun DayOutcomes(preview: CopyPreview, showSource: Boolean) {
    val content = LocalContentColor.current
    Column(verticalArrangement = Arrangement.spacedBy(2.dp), modifier = Modifier.padding(top = 4.dp)) {
        preview.byDay.forEach { (day, outcome) ->
            val text = when (outcome) {
                is DayCopyOutcome.Copied -> buildString {
                    append(pluralStringResource(Res.plurals.copy_day_day_shifts, outcome.shifts, outcome.shifts))
                    // SH-199: what happens to the day's own shifts.
                    if (outcome.replaces > 0) append(", ").append(stringResource(Res.string.copy_day_day_replaces, outcome.replaces))
                    if (outcome.keptTotal > 0) append(", ").append(stringResource(Res.string.copy_day_day_kept, outcome.keptTotal))
                    if (outcome.alongside > 0) append(", ").append(stringResource(Res.string.copy_day_day_alongside, outcome.alongside))
                    if (outcome.leftOpenTotal > 0) {
                        append(", ")
                        append(pluralStringResource(Res.plurals.copy_day_day_without, outcome.leftOpenTotal, outcome.leftOpenTotal))
                        val reasons = CopyOpenReason.entries.mapNotNull { reason ->
                            outcome.leftOpen[reason]?.takeIf { it > 0 }?.let { reason to it }
                        }
                        if (reasons.isNotEmpty()) {
                            append(" (")
                            append(reasons.map { (reason, count) -> copyReasonText(reason, count) }.joinToString(", "))
                            append(")")
                        }
                    }
                }
                is DayCopyOutcome.SkippedClosed -> stringResource(Res.string.copy_day_skipped_closed, closureLabel(outcome.closure).lowercase())
                DayCopyOutcome.SkippedPlanned -> stringResource(Res.string.copy_day_skipped_planned)
                DayCopyOutcome.NothingToCopy -> null
            } ?: return@forEach
            val source = preview.days[day]
            val line = if (showSource && source != null) {
                stringResource(Res.string.copy_day_line_from, dayAndDate(day), dayAndMonth(source), text)
            } else {
                stringResource(Res.string.copy_day_line, dayAndDate(day), text)
            }
            val muted = outcome !is DayCopyOutcome.Copied
            val warn = outcome is DayCopyOutcome.Copied && outcome.leftOpenTotal > 0
            Text(
                line,
                color = when {
                    warn -> LightGold
                    muted -> content.copy(alpha = 0.6f)
                    else -> content.copy(alpha = 0.9f)
                },
                style = MaterialTheme.typography.bodySmall,
                modifier = Modifier.testTag(CopyToolTags.outcome(day))
            )
        }
    }
}

@Composable
private fun copyReasonText(reason: CopyOpenReason, count: Int): String = stringResource(copyReasonRes(reason), count)
